










































import { Component, Prop, Vue } from "vue-property-decorator";
import { News } from "@/services/news/types";
import FunctionalCalendar from "vue-functional-calendar/src/components/FunctionalCalendar.vue";
import i18n from "@/i18n";

@Component({
    components: {
        "functional-calendar": FunctionalCalendar
    }
})
export default class NewsSchedule extends Vue {
    @Prop() private item!: News;
    disabledDates = [];
    showCalendar = true;

    // lifecycle hooks
    mounted() {
        var fromDate = !this.item.fromDate ? new Date() : new Date(this.item.fromDate);
        (this.$refs.calendarFromDate as any).clickDay({
            day: fromDate.getDate(),
            date: `${fromDate.getDate()}/${fromDate.getMonth() + 1}/${fromDate.getFullYear()}`,
            isMarked: true
        });
        if (this.item.toDate) {
            var toDate = new Date(this.item.toDate);
            (this.$refs.calendarToDate as any).clickDay({
                day: toDate.getDate(),
                date: `${toDate.getDate()}/${toDate.getMonth() + 1}/${toDate.getFullYear()}`,
                isMarked: true
            });
        }
    }

    // methods

    getFromDateLabel() {
        return new Date(this.item.fromDate).toLocaleString("en-US", { year: "numeric", month: "long", day: "numeric" });
    }

    getToDateLabel() {
        var text = this.item.toDate
            ? new Date(this.item.toDate).toLocaleString("en-US", { year: "numeric", month: "long", day: "numeric" })
            : i18n.t("news.selectEndDate");
        return text;
    }

    // computed

    get fromDate() {
        return {
            currentDate: new Date(),
            selectedDate: new Date(this.item.fromDate)
        };
    }

    set fromDate(date: any) {
        const dateParts = date.selectedDate.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        this.item.fromDate = dateObject.toDateString();
    }

    get toDate() {
        return {
            currentDate: new Date(),
            selectedDate: this.item.toDate
        };
    }

    set toDate(date: any) {
        const dateParts = date.selectedDate.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        this.item.toDate = dateObject.toDateString();
    }

    checkIfFormIsValid() {
        this.$emit("scheduleUpdated", this.fromDate < this.toDate);
    }
}
